import { useIntl } from 'react-intl';
import { AsideMenuItem } from './AsideMenuItem';
import { useSelector } from 'react-redux';
import { authUserSelector } from '../../../../app/modules/auth';
import authorizedB2BViewers from '../../../../app/modules/b2b-orders/constants/authorizedB2BViewers';

export function AsideMenuB2B() {
  const intl = useIntl();
  const authUser = useSelector(authUserSelector);
  const isB2BUser = !!authUser?.groups?.find((aGroup) => aGroup.name === 'B2B');
  const isAuthorizedB2BViewer = authorizedB2BViewers.includes(authUser?.email);

  if (!isB2BUser && !isAuthorizedB2BViewer) return <></>;

  return (
    <>
      <h5 className="menu-title text-light pb-4 mb-0 mt-2 ms-6">
        {intl.formatMessage({ id: 'menu.b2b' })}
      </h5>
      {isB2BUser && (
        <AsideMenuItem
          to={`/search-shops`}
          title={intl.formatMessage({ id: 'menu.searchShops' })}
          fontIcon="fa-search"
        />
      )}
      {isB2BUser && (
        <AsideMenuItem
          to={`/lead-distributors`}
          title={intl.formatMessage({ id: 'menu.leadDistributors' })}
          fontIcon="fa-handshake"
        />
      )}
      {isB2BUser && (
        <AsideMenuItem
          to={`/b2b-lead-orders`}
          title={intl.formatMessage({ id: 'menu.b2bLeadOrders' })}
          fontIcon="fa-gift"
        />
      )}
      {isB2BUser && (
        <AsideMenuItem
          to={`/shops`}
          title={intl.formatMessage({ id: 'menu.shops' })}
          fontIcon="fa-store"
        />
      )}
      <AsideMenuItem
        to={`/distributors`}
        title={intl.formatMessage({ id: 'menu.distributors' })}
        fontIcon="fa-truck"
      />
      {isB2BUser && (
        <AsideMenuItem
          to={`/suppliers`}
          title={intl.formatMessage({ id: 'menu.suppliers' })}
          fontIcon="fa-industry"
        />
      )}
      <AsideMenuItem
        to={`/b2b-orders`}
        title={intl.formatMessage({ id: 'menu.b2bOrders' })}
        fontIcon="fa-box"
      />
      {isB2BUser && (
        <AsideMenuItem
          to={`/delivery-notes`}
          title={intl.formatMessage({ id: 'menu.deliveryNotes' })}
          fontIcon="fa-file-alt"
        />
      )}
      {isB2BUser && (
        <AsideMenuItem
          to={`/invoices`}
          title={intl.formatMessage({ id: 'menu.invoices' })}
          fontIcon="fa-file-invoice-dollar"
        />
      )}
      <div className="menu-item">
        <div className="menu-content">
          <div className="separator mx-1 my-4"></div>
        </div>
      </div>
    </>
  );
}
